import { render, staticRenderFns } from "./MediaViewer.vue?vue&type=template&id=11624694&"
import script from "./MediaViewer.vue?vue&type=script&lang=js&"
export * from "./MediaViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/MediaViewer.vue
// module id = null
// module chunks = 